import { render, staticRenderFns } from "./xhExpenses.vue?vue&type=template&id=0ddca957&scoped=true"
import script from "./xhExpenses.vue?vue&type=script&lang=js"
export * from "./xhExpenses.vue?vue&type=script&lang=js"
import style0 from "./xhExpenses.vue?vue&type=style&index=0&id=0ddca957&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddca957",
  null
  
)

export default component.exports